export default __webpack_public_path__ + "static/no-results-810d67e2e4417cfbf4b53b9b0743a30d5b21a9c1f8a761a9a9b9711ec9ae3cfe.png";